;(function($) {

    var contentOverflow = $.fn.contentOverflow = function(options) {
        contentOverflow.elements = this;
        contentOverflow._init();
        contentOverflow._apply();
        return this;
    };

    contentOverflow._init = function(){
        console.debug('contentOverflow init');

        this.elements.each(function(){
            var elt = $(this);
            elt.data({
                'pl' : parseInt(elt.css('paddingLeft'), 10),
                'pr' : parseInt(elt.css('paddingLeft'), 10)
            });
        });
    };

    contentOverflow._apply = function() {

        if(this.elements != undefined){
            this.elements.each(function(){


                var elt = $(this);

                if(elt.hasClass('overflow--left')){

                    // on reset la valeur
                    elt.css("marginLeft", 0);
                    elt.find(' > div').css({
                        paddingLeft: 0
                    });

                    var offset = verge.rectangle(this);
                    elt.css("marginLeft", -offset.left);
                    elt.find(' > div').css("paddingLeft", offset.left -elt.data('pl'));
                }

                if(elt.hasClass('overflow--right')){

                    // on reset la valeur
                    elt.css("marginRight", 0);
                    elt.find(' > div').css({
                        paddingRight: 0
                    });

                    var rec = verge.rectangle(this);
                    var offset = verge.viewportW() - rec.right;
                    elt.css("marginRight", -offset);
                    elt.find(' > div').css("paddingRight", offset - elt.data('pr'));
                }

            });
        }
        return this;
    };

    $(window).bind('load', function(event) {
        //contentOverflow._apply();
    });

    $(window).bind('resize orientationchange', function(event) {
        try{
            SG_debounce(contentOverflow._apply(), 500);
        } catch(err){
            if(err instanceof ReferenceError){
                console.log("il faut une fonction de debounce nommé SG_debounce");
            }
        }
    });


})(jQuery);